import React, { useMemo } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import type { Locale } from 'antd/es/locale';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import zhTW from 'antd/locale/zh_TW';
import { useTranslation } from 'react-i18next';
import AppRouter from './router';
import { ErrorBoundary } from '@/components';
import { AuthProvider } from '@/modules/auth';
import { BrandingProvider } from '@/modules/foundation/contexts';
import { useTenantTheme } from '@/hooks/useTenantTheme';
import { AntdStaticProvider } from '@/utils/antdStatic';
// 初始化 i18n
import '@/locales';
// import AuthInit from './components/common/AuthInit';
import './App.css';

// Ant Design 语言包映射
const antdLocales: Record<string, Locale> = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'zh-TW': zhTW,
};

/**
 * 内部应用组件，用于在 useTenantTheme 可用后应用主题
 */
const AppContent: React.FC = () => {
  const { antdTheme } = useTenantTheme();
  const { i18n } = useTranslation();

  // 根据当前语言获取 Ant Design 语言包
  const antdLocale = useMemo(() => {
    return antdLocales[i18n.language] || zhCN;
  }, [i18n.language]);

  return (
    <ConfigProvider locale={antdLocale} theme={antdTheme}>
      <AntdApp>
        <AntdStaticProvider />
        <AuthProvider>
          {/* 认证状态初始化 - 开发阶段暂时注释 */}
          {/* <AuthInit /> */}
          {/* 路由系统 */}
          <AppRouter />
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

const App: React.FC = () => {
  console.log('🎯 App组件正在渲染');

  return (
    <ErrorBoundary>
      <BrandingProvider>
        <AppContent />
      </BrandingProvider>
    </ErrorBoundary>
  );
};

export default App;
